var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "订单操作日志",
        visible: _vm.dialogTableVisible,
        "before-close": _vm.closeDialog,
        width: "800px",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogTableVisible = $event
        },
      },
    },
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: { data: _vm.tableData, "max-height": "550" },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "optCreateTime", label: "操作时间", width: "150" },
          }),
          _c("el-table-column", {
            attrs: { prop: "optUserName", label: "操作人", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [
                      _vm._v(
                        _vm._s(
                          scope.row.optUserName || scope.row.optUserId || ""
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "optDesc", label: "操作详情" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return _vm._l(scope.row.optDesList, function (item, idx) {
                    return _c("div", { key: idx }, [_vm._v(_vm._s(item))])
                  })
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }